import { useRef } from "react"
import styled from "styled-components"
import { Header, Sidebar } from "~/components"
import { ContentScrollProvider } from "../../containers/ContentScrollProvider"

import { AuthRoutes } from "./AuthRoutes"

const Wrapper = styled.div`
  display: block;
  height: 100%;
  width: 100%;
`

const ContentWrapper = styled.div`
  grid-area: main;
  height: 100%;

  background-color: ${(props) => props.theme.colors.defaultBackground};
  overflow-x: hidden;
`

const HeaderWrapper = styled.header`
  grid-area: header;

  ${(props) => props.theme.media.pad} {
    width: 100%;
    position: fixed;
    top: 0;
    left: 0;
    z-index: 3;
  }
`

const InnerWrapper = styled.div`
  display: grid;
  grid-template-columns: auto 1fr;
  grid-template-rows: ${(props) => props.theme.sizes.headerHeight} 1fr;
  height: 100%;

  background: ${(props) => props.theme.colors.defaultBackground};

  grid-template-areas:
    'header header'
    'sidebar main';

  ${(props) => props.theme.media.pad} {
    grid-template-columns: 100%;
    grid-template-rows: 56px 1fr;

    grid-template-areas:
      'header'
      'main';
  }
`

const SidebarWrapper = styled.div`
  grid-area: sidebar;
  width: 256px;

  ${(props) => props.theme.media.pad} {
    grid-area: main;
  }
`

export const MainLayout = () => {
  const contentRef = useRef<HTMLDivElement | null>(null)

  return (
    <Wrapper>
      <InnerWrapper>
        <HeaderWrapper>
          <Header />
        </HeaderWrapper>

        <SidebarWrapper>
          <Sidebar />
        </SidebarWrapper>

        <ContentWrapper ref={contentRef}>
          {/* This ContentWrapper element is responsible for the main body-scroll, so we add a context provider here */}
          <ContentScrollProvider contentRef={contentRef}>
            <AuthRoutes />
          </ContentScrollProvider>
        </ContentWrapper>
      </InnerWrapper>
    </Wrapper>
  )
}
